import { call, select } from 'redux-saga/effects';
import { selectContentLibraryOpenedFile } from 'features/content-library/contentLibrarySlice';
import { ContentLibraryOpenedFile } from 'features/content-library/types';
import { isContentLibraryMediaPlayer } from 'features/content-library/utils/isContentLibraryMediaPlayer';
import { selectGridPanelCollapsed } from 'features/layout/features/content/contentSlice';

/**
 * No-op for media-player files.
 *
 * A layout-driven cascade must not re-fetch server state — the live broadcast
 * stream is the source of truth, and a snapshot fetch can produce seek-backs.
 * Selectors stay for parity — delete in a follow-up if no media-player path remains.
 */
export function* onStreamMinimizedSaga() {
  const openedFile: ContentLibraryOpenedFile | null = yield select(selectContentLibraryOpenedFile);
  const gridPanelCollapsed: boolean = yield select(selectGridPanelCollapsed);

  if (gridPanelCollapsed || !openedFile) {
    return;
  }

  yield call(isContentLibraryMediaPlayer, openedFile);
}
